export default __webpack_public_path__ + "static/media/Hi.d9372093.gif";